<template>
  <label class="container">
    <span v-html="label" class="label" :class="{ marked: value }" />
    <input
      type="checkbox"
      :checked="value"
      @input="$emit('input', $event.target.checked)"
    />
    <span :class="{ checkmark: true, marked: value }" />
  </label>
</template>
<script>
export default {
  props: {
    label: String,
    value: Boolean,
  },
};
</script>
<style lang="stylus" scoped>
.container
  align-items: flex-start
  cursor: pointer
  display: block
  padding-left: vw(35px)
  position: relative
  user-select: none
  -moz-user-select: none
  -ms-user-select: none
  -webkit-user-select: none

  input
    cursor: pointer
    height: 0
    opacity: 0
    position: absolute
    width: 0

.checkmark
  m-icon("checkbox-off", 22)
  left: 0
  position: absolute
  top: 50%
  transform: translate(0, -50%)

  &.marked
    m-icon("checkbox-on", 22)
    left: 0
    position: absolute
    top: 50%
    transform: translate(0, -50%)
</style>